// Copyright (C) Microsoft Corporation. All rights reserved.

import { InitializeExpandableNavigationGallery } from './ExpandableNavigationGallery';

(<any>window).InitializeExpandableNavigationGallery = InitializeExpandableNavigationGallery;
